var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10.5 12",
    style: {
      enableBackground: "new 0 0 10.5 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,0.8h-9C0.3,0.8,0,1.1,0,1.5v9c0,0.4,0.3,0.8,0.7,0.8h9c0.4,0,0.8-0.3,0.8-0.8v-9 C10.5,1.1,10.2,0.8,9.8,0.8z M3.2,9.8H1.6v-5h1.6L3.2,9.8L3.2,9.8z M2.4,4.1c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9 c0.5,0,0.9,0.4,0.9,0.9C3.3,3.7,2.9,4.1,2.4,4.1z M9,9.8H7.5V7.3c0-0.6,0-1.3-0.8-1.3C5.8,6,5.7,6.6,5.7,7.3v2.5H4.2v-5h1.5v0.7h0 C5.9,5,6.4,4.6,7.1,4.6C8.7,4.6,9,5.7,9,7V9.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.32b8dd298b4f6578e6756fbae9b9f1b9.svg";
export { ForwardRef as ReactComponent };